import {Component} from '@angular/core';
/**
 * \@title Tooltip with custom position
 */
export class TooltipPositionExample {
  position = 'before';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tooltip-position-example',
  templateUrl: 'tooltip-position-example.html',
  styleUrls: ['tooltip-position-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TooltipPositionExample_tsickle_Closure_declarations() {
/** @type {?} */
TooltipPositionExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TooltipPositionExample.ctorParameters;
/** @type {?} */
TooltipPositionExample.prototype.position;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
